if (!customElements.get('std-collection-description')) {
  customElements.define('std-collection-description', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.content = this.querySelector('[data-description-content]');
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-description-label]');
      this.expanded = false;
      this.button.onclick = () => {
        this.expanded = !this.expanded;
        this.update();
      };
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.content);
      this.update();
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.initialized = false;
    }
    update() {
      const first = Array.from(this.content.querySelectorAll('*')).find(el => el.textContent.trim() && getComputedStyle(el).display !== 'none') || this.content;
      const style = getComputedStyle(first);
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
      const offset = Math.max(0, first.getBoundingClientRect().top - this.content.getBoundingClientRect().top);
      const height = Math.ceil(offset + lineHeight * 2);
      this.style.setProperty('--std-description-height', height + 'px');
      const hasMore = this.content.scrollHeight > height + 2;
      this.button.hidden = !hasMore;
      this.toggleAttribute('data-collapsed', hasMore && !this.expanded);
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.label.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;
      const bottom = this.content.getBoundingClientRect().top + height;
      this.content.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(el => {
        const clipped = hasMore && !this.expanded && el.getBoundingClientRect().bottom > bottom;
        if (clipped && !el.hasAttribute('data-std-tabindex')) {
          el.setAttribute('data-std-tabindex', el.getAttribute('tabindex') ?? '');
          el.setAttribute('tabindex', '-1');
        } else if (!clipped && el.hasAttribute('data-std-tabindex')) {
          const original = el.getAttribute('data-std-tabindex');
          if (original) el.setAttribute('tabindex', original); else el.removeAttribute('tabindex');
          el.removeAttribute('data-std-tabindex');
        }
      });
    }
  });
}
